import script from "./ChatNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatNotification.vue?vue&type=script&setup=true&lang=js"

import "./ChatNotification.vue?vue&type=style&index=0&id=4d2abc12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2abc12"]])

export default __exports__